import {Show, VStack} from 'platform/foundation';

import {
  VehicleForm as VFKit,
  VehicleSubSections as VFSubSection,
  VehicleFormDefaultLayout,
  useIsCardExpandable,
  isElectricOrHybridFuelType,
} from '@dms/features/vehicle-forms-kit';
import i18n from '@dms/i18n';

import {AdditionalInfoWidget} from '../components/AdditionalInfoWidget';

interface ServiceVehicleDataProps {
  shouldShowWarranties: boolean;
}

export function ServiceVehicleData(props: ServiceVehicleDataProps) {
  const isExpandable = useIsCardExpandable();

  return (
    <VehicleFormDefaultLayout>
      <VehicleFormDefaultLayout.Left>
        <VStack spacing={4}>
          <VFKit.Section
            data-testid="vehicle-data"
            isExpandable={isExpandable}
            title={isExpandable ? i18n.t('entity.vehicle.labels.vehicleData') : undefined}
          >
            <VFKit.OtherRecordsTextarea />
            <VFKit.ShowWhen
              name="fuelType"
              condition={(fuelType) => isElectricOrHybridFuelType(fuelType?.[0])}
            >
              <VFSubSection.BatteryHealth />
            </VFKit.ShowWhen>
            <VFSubSection.Warranty />
            <Show when={props.shouldShowWarranties}>
              <VFSubSection.Warranties />
            </Show>
            <VFSubSection.TechnicalInspection />
            <VFSubSection.ServiceBook />
            <VFSubSection.ServiceInspection />
          </VFKit.Section>
        </VStack>
      </VehicleFormDefaultLayout.Left>
      <VehicleFormDefaultLayout.Right>
        <VFKit.SubSection data-testid="additional-info">
          <AdditionalInfoWidget />
        </VFKit.SubSection>
      </VehicleFormDefaultLayout.Right>
    </VehicleFormDefaultLayout>
  );
}
